import { esCorreoCorporativo } from '@/views/recognition/access/accessErrors';
import type { FrontlineUserAdminDto } from '@/api/types';

/**
 * ¿El correo con el que entra la persona (el de la ficha) es de un dominio corporativo y no hay otro corporativo
 * distinto en SuccessFactors? En ese caso la lista y el modal lo pintan en la columna CORPORATIVA, no en la personal.
 * Solo cambia dónde se pinta: enviar, editar y el historial siguen usando `correoPersonal`. Una cuenta del AD nunca
 * entra aquí: ya muestra su correo en la columna corporativa por su propia regla.
 */
export function personalEsCorporativo(user: FrontlineUserAdminDto, ssoDomains: readonly string[] | undefined): boolean {
  if (user.estado === 'DelDirectorio' || !user.correoPersonal) return false;
  if (!esCorreoCorporativo(user.correoPersonal, ssoDomains)) return false;
  return !user.correoCorporativo
    || user.correoCorporativo.trim().toLowerCase() === user.correoPersonal.trim().toLowerCase();
}

/**
 * Ficha del padrón SIN RECLAMAR cuyo correo es de un dominio de SSO: la persona entra con su cuenta corporativa, así que
 * no se le agrega un correo personal ni se le manda el enlace de activación (el servidor también lo rechaza,
 * `acceso-por-sso`). Una cuenta ya reclamada no entra aquí: su correo es su credencial y sí se puede corregir.
 */
export function accesoPorSso(user: FrontlineUserAdminDto, ssoDomains: readonly string[] | undefined): boolean {
  return !user.reclamada && personalEsCorporativo(user, ssoDomains);
}
